
import ContactForm from "@/components/base/form/ContactForm"
import structuredDataHomepage from "@/mixins/structuredDataHomepage"

export default {
    components: { ContactForm },
    mixins: [structuredDataHomepage],
    layout(context) {
        const user = context.$auth.user
        if (user?.school || user?.business || user?.region) {
            return "modern"
        }
        return "default"
    },
    meta: {
        toolbar: {
            persistentLogo: true,
            persistent: true,
            hideSearch: true,
        },
        hideBottomNav: true,
    },
    head() {
        return {
            title: "Kontakt & Fragen | Oabat GmbH",
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content:
                        "Du hast Fragen zu Oabat oder willst selbst Teil von Oabat sein? Schreib uns!",
                },
                {
                    hid: "og:title",
                    name: "og:title",
                    content: "Kontakt & Fragen | Oabat GmbH",
                },
                {
                    hid: "og:description",
                    name: "og:description",
                    content:
                        "Du hast Fragen zu Oabat oder willst selbst Teil von Oabat sein? Schreib uns!",
                },
            ],
            __dangerouslyDisableSanitizers: ["script"],
            script: this.getStructuredHomepageData(),
        }
    },
}
